import { render, staticRenderFns } from "./Referal.vue?vue&type=template&id=62673ed0&scoped=true&"
import script from "./Referal.vue?vue&type=script&lang=js&"
export * from "./Referal.vue?vue&type=script&lang=js&"
import style0 from "./Referal.vue?vue&type=style&index=0&id=62673ed0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62673ed0",
  null
  
)

export default component.exports